import React from 'react';
import { Flame, FileText, Wrench, Settings2 } from 'lucide-react';

/** Shared sub-tabs for Technical section (Heat Profile, Test Repository, DCAL, Coil Configurator). */
export const TECHNICAL_TAB_ITEMS = [
    { id: 'heat-profile', label: 'Heat Profile', path: '/heat-profile', icon: <Flame size={18} /> },
    { id: 'test-repository', label: 'Test Repository', path: '/TechnicalPage', icon: <FileText size={18} /> },
    { id: 'dcal-generator', label: 'DCAL Generator', path: '/DCALGenerator', icon: <Wrench size={18} /> },
    {
        id: 'coil-configurator',
        label: 'Coil Configurator',
        path: '/coil-configurator',
        icon: <Settings2 size={18} />,
    },
];

/** Routes that belong under the Technical sidebar section (includes legacy /technical landing). */
export const TECHNICAL_NAV_PATHS = [
    '/technical',
    ...TECHNICAL_TAB_ITEMS.map((item) => item.path),
];

export const isTechnicalNavPath = (pathname = '') =>
    TECHNICAL_NAV_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
